<template>
  <div :class="componentClassName">
    <section class="t-vdxb-entry-sidebar__sidebar">
      <div class="t-vdxb-entry-sidebar__sidebar-holder">
        <div class="t-vdxb-entry-sidebar__logo">
          <div class="t-vdxb-entry-sidebar__logo-coperate">
            <img src="@/images/corporatebrandmark.svg" alt="" />
          </div>
          <div class="t-vdxb-entry-sidebar__logo-cotoha">
            <img src="@/images/COTOHA_VoiceDX_Basic.svg" alt="" />
          </div>
        </div>
        <a-vdxb-heading :heading="sidebarHeading" tag="h1" subheading-tag="span" :subheading="sidebarSubHeading" />
        <m-vdxb-progress :steps="sidebarList" :current="sidebarCurrent" class="t-vdxb-entry-sidebar__progress" />
      </div>
    </section>
    <section class="t-vdxb-entry-sidebar__body">
      <div class="t-vdxb-entry-sidebar__content">
        <slot name="alert"></slot>
        <a-vdxb-heading
          :heading="heading"
          tag="h1"
          subheading-tag="span"
          :subheading="subHeading"
          variant="border"
          class="t-vdxb-entry-sidebar__heading"
        />
        <slot>Content</slot>
      </div>
      <o-global-footer v-if="footer" class="t-vdxb-entry-sidebar__footer" />
    </section>
  </div>
</template>

<script>
import { mapModifiers } from '@/libs/component';

import AVdxbHeading from '@/components/atoms/vdxb-heading';
import MVdxbProgress from '@/components/molecules/vdxb-progress';
import OGlobalFooter from '@/components/organisms/global-footer';

import Simplebar from 'simplebar';

export default {
  name: 't-vdxb-default-vdxb-entry-sidebar',
  components: {
    AVdxbHeading,
    MVdxbProgress,
    OGlobalFooter,
  },
  props: {
    class: {
      type: String,
      default: '',
    },
    sidebarHeading: {
      type: String,
      default: null,
    },
    sidebarSubHeading: {
      type: String,
      default: null,
    },
    sidebarList: {
      type: Array,
      default: new Array(0),
    },
    sidebarCurrent: {
      type: [String, Number],
      default: null,
    },
    heading: {
      type: String,
      default: null,
    },
    subHeading: {
      type: String,
      default: null,
    },
    footer: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    componentClassName() {
      const baseClassName = mapModifiers('t-vdxb-entry-sidebar', this.$slots.alert ? 'with-alert' : '');
      return `${baseClassName} ${this.class}`.trim();
    },
  },
  mounted() {
    new Simplebar(this.$el.querySelector('.t-vdxb-entry-sidebar__sidebar-holder'));
  },
};
</script>
